import { render, staticRenderFns } from "./reCheckedTaskDialog.vue?vue&type=template&id=08520b70"
import script from "./reCheckedTaskDialog.vue?vue&type=script&lang=js"
export * from "./reCheckedTaskDialog.vue?vue&type=script&lang=js"
import style0 from "./reCheckedTaskDialog.vue?vue&type=style&index=0&id=08520b70&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports